import TracingNoop from './TracingNoop';
import TracingSplunk from './TracingSplunk'; // Initialize a no-op tracing helper for safety

var tracing = new TracingNoop();
export var getTracing = function getTracing() {
  return tracing;
};
export var initTracing = function initTracing(config) {
  var beaconEndpoint = config.beaconEndpoint,
      debug = config.debug;
  var canUseTracing = debug || !!beaconEndpoint;
  var TracingClass = canUseTracing ? TracingSplunk : TracingNoop;
  tracing = new TracingClass(config);
  return tracing;
};